import { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { exchangeGoogleCode, signInWithGoogle, useAuth, validateGoogleAuthState } from "../services/auth";
import "../assets/styles/Login.css";

const Login = () => {
  const [user, loading] = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState("");
  const [isExchangingCode, setIsExchangingCode] = useState(false);

  useEffect(() => {
    const code = searchParams.get("code");
    if (!code) return;

    const handleGoogleCallback = async () => {
      try {
        setIsExchangingCode(true);
        if (!validateGoogleAuthState(searchParams.get("state"))) {
          throw new Error("Invalid Google login state");
        }
        await exchangeGoogleCode(code);
        navigate("/", { replace: true });
      } catch (error) {
        setLoginError(error?.response?.data?.errors?.[0]?.detail || error.message || "Login failed");
      } finally {
        setIsExchangingCode(false);
      }
    };

    handleGoogleCallback();
  }, [navigate, searchParams]);

  if (loading || isExchangingCode)
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "600px",
          width: "100%",
        }}
      >
        <CircularProgress />
      </Box>
    );

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="login">
      <div className="login__container">
        <button
          className="login__btn login__google"
          onClick={() => {
            try {
              signInWithGoogle();
            } catch (error) {
              setLoginError(error.message);
            }
          }}
        >
          Login with Google
        </button>
        {loginError && <div className="login__error">{loginError}</div>}
      </div>
    </div>
  );
};

export default Login;
